import { render, staticRenderFns } from "./AvgUser.vue?vue&type=template&id=62a59cb2&scoped=true"
import script from "./AvgUser.vue?vue&type=script&lang=js"
export * from "./AvgUser.vue?vue&type=script&lang=js"
import style0 from "./AvgUser.vue?vue&type=style&index=0&id=62a59cb2&prod&scoped=true&lang=css"
import style1 from "./AvgUser.vue?vue&type=style&index=1&id=62a59cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a59cb2",
  null
  
)

export default component.exports